import { DateTime } from 'luxon';

import { getDateFormatForLocale, getLanguage } from '@/globals';
import i18n from '@/vueI18n';

import RequiredEvaluator from './RequiredEvaluator';

export default class BeforeEvaluator extends RequiredEvaluator {
  dateType: string;

  constructor(fieldName, friendlyFieldName, model, mutator = null) {
    super(fieldName, friendlyFieldName, model, mutator);
    this.evaluatorName = 'before';
  }

  validate() {
    this.isValid = super.validate();
    this.isValid = this.isValid && this.mutator[0];
    const format = getDateFormatForLocale(getLanguage()); // Default to english when running unit tests.
    if (this.isValid) {
      const left = this.value instanceof DateTime ? this.value : DateTime.fromFormat(this.value, format);
      let right = null;
      if (this.mutator[0] in this.model) {
        right =
          this.model[this.mutator[0]] instanceof DateTime
            ? this.model[this.mutator[0]]
            : DateTime.fromFormat(this.model[this.mutator[0]], format);
        this.dateType = 'model';
      } else {
        right = DateTime.fromFormat(this.mutator[0], format);
        this.dateType = 'raw';
      }
      this.isValid = left < right;
    }
    return this.isValid;
  }

  getMessage(validatorDictionary) {
    if (this.isValid) {
      return {
        type: 'valid',
        message: '',
      };
    }
    const func = validatorDictionary[this.evaluatorName];
    if (this.dateType === 'model') {
      this.mutator[0] = i18n.global.t(`validatorNames.${this.mutator[0]}`);
    }
    return {
      type: 'error',
      message: func(this.friendlyFieldName, this.mutator),
    };
  }
}
